import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
/** Shown from the "cancel my pending request" control (dropdown/FriendsPage) — the outgoing-tab equivalent of RequestsModal's inline cancel button. */
export default class CancelRequestConfirmModal extends Modal {
  loading = false;
  className() {
    return 'FriendshipConfirmModal Modal--small';
  }
  title() {
    return app.translator.trans('forumaker-friendship.forum.cancel_request_modal.title');
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "FriendshipConfirmModal-text"
    }, app.translator.trans('forumaker-friendship.forum.cancel_request_modal.text', {
      user: this.attrs.user
    })), m("div", {
      className: "FriendshipConfirmModal-actions"
    }, m(Button, {
      className: "Button Button--danger Button--block",
      icon: "fas fa-ban",
      loading: this.loading,
      onclick: () => this.cancel()
    }, app.translator.trans('forumaker-friendship.forum.cancel_request_modal.confirm_btn')), m(Button, {
      className: "Button Button--block",
      disabled: this.loading,
      onclick: () => this.hide()
    }, app.translator.trans('forumaker-friendship.forum.cancel_request_modal.cancel_btn'))));
  }
  async cancel() {
    const requestId = this.attrs.user.attribute('friendshipPendingOutgoingRequestId');
    if (!requestId) {
      this.hide();
      return;
    }
    this.loading = true;
    m.redraw();
    try {
      await app.request({
        method: 'DELETE',
        url: `${app.forum.attribute('apiUrl')}/friendship-requests/${requestId}`
      });
      this.attrs.user.pushAttributes({
        friendshipHasPendingOutgoing: false,
        friendshipPendingOutgoingRequestId: null
      });
      this.hide();
      this.attrs.onChange?.();
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('forumaker-friendship.forum.requests_modal.cancel_success'));
    } catch (error) {
      this.loading = false;
      m.redraw();
      throw error;
    }
  }
}
flarum.reg.add('forumaker-friendship', 'forum/components/CancelRequestConfirmModal', CancelRequestConfirmModal);